import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { CouponAttachmentContainerModel } from '../../../../../../models/aggregates/erp/coupon/coupon-attachment-container.model';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa } from '../../shared';
import { Observable } from 'rxjs';
import { FilesDetailsRequest } from '../../../../../../models/file-image';


@Injectable({
  providedIn: 'root'
})
export class CouponAttchmentService extends BaseApiTemplateService<CouponAttachmentContainerModel> {


  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'coupons/attachments/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'coupons/attachments/backoffice-ep';
    this.httpClient = http;
  }

  getCouponAttachmentFile(guid: string, apiVisa: ApiVisa): Observable<Blob> {
    let url;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'coupons/attachments/file/backoffice-ep/' + guid;
    }
    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(apiVisa)
    );
  }

  addCouponAttachmentsAndDetails(guid: string, files: File[], visa: ApiVisa,
    filesDetails?: FilesDetailsRequest) {
    let url;

    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'coupons/attachments/add-files/backoffice-ep/' + guid;
    }

    const formData: FormData = new FormData();
    files.forEach(file => {
      formData.append('files', file)
    });
    
    if (filesDetails) {
      formData.set(
        'files-data',
        new Blob([JSON.stringify(filesDetails)], { type: 'application/json' }),
        'files-data.json')
    }

    return this.httpClient.put<ApiResponseModel<any>>(
      url,
      formData,
      this.getHttpHeader(visa)
    );
  }

  updateCouponAttachments(guid: string, file: File, visa: ApiVisa) {
    let url;

    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'coupons/attachments/replace-file/backoffice-ep/' + guid;
    }

    const formData: FormData = new FormData();
    formData.append('file', file);

    return this.httpClient.put<ApiResponseModel<any>>(
      url,
      formData,
      this.getHttpHeader(visa)
    );
  }
}
